import { createAction } from 'redux-actions';

export const getProductsByCompanyRequested = createAction('GET_PRODUCTS_BY_COMPANY_REQUEST');
export const getProductsByCompanyReceived = createAction('GET_PRODUCTS_BY_COMPANY_RECEIVED');
export const getProductsByCompanyReceiveFailure = createAction('GET_PRODUCTS_BY_COMPANY_RECEIVE_FAILURE');
export const getProductsByCompanyClear = createAction('GET_PRODUCTS_BY_COMPANY_CLEAR');

export const getProductInfoRequested = createAction('GET_PRODUCT_INFO_REQUEST');
export const getProductInfoReceived = createAction('GET_PRODUCT_INFO_RECEIVED');
export const getProductInfoReceiveFailure = createAction('GET_PRODUCT_INFO_RECEIVE_FAILURE');
export const getProductInfoClear = createAction('GET_PRODUCT_INFO_CLEAR');

export const createProductRequested = createAction('CREATE_PRODUCT_REQUEST');
export const createProductReceived = createAction('CREATE_PRODUCT_RECEIVED');
export const createProductReceiveFailure = createAction('CREATE_PRODUCT_RECEIVE_FAILURE');
export const createProductClear = createAction('CREATE_PRODUCT_CLEAR');

export const updateProductRequested = createAction('UPDATE_PRODUCT_REQUEST');
export const updateProductReceived = createAction('UPDATE_PRODUCT_RECEIVED');
export const updateProductReceiveFailure = createAction('UPDATE_PRODUCT_RECEIVE_FAILURE');
export const updateProductClear = createAction('UPDATE_PRODUCT_CLEAR');

export const deleteProductRequested = createAction('DELETE_PRODUCT_REQUEST');
export const deleteProductReceived = createAction('DELETE_PRODUCT_RECEIVED');
export const deleteProductReceiveFailure = createAction('DELETE_PRODUCT_RECEIVE_FAILURE');
export const deleteProductClear = createAction('DELETE_PRODUCT_CLEAR');

// progess create product
export const createProductProgess = createAction('CREATE_PRODUCT_PROGESS');

export const updateProductOrderRequested = createAction('UPDATE_PRODUCT_ORDER_REQUESTED');
export const updateProductOrderReceived = createAction('UPDATE_PRODUCT_ORDER_RECEIVED');
export const updateProductOrderReceiveFailure = createAction('UPDATE_PRODUCT_ORDER_RECEIVE_FAILURE');
export const clearUpdateProductOrder = createAction('CLEAR_UPDATE_PRODUCT_ORDER');
